const deposit_reducer = (state = 0, action) => {
	switch(action.type) {

		case 'UPDATEDEPOSIT':
			return action.payload;

		default:
			return state;
	}
}

export default deposit_reducer;